






































import WeeklyConsumptionPanel from "@dcc/components/WeeklyConsumptionPanel.vue";
//eslint-disable-next-line
import { Drinks } from "@dcc/types/drinks";
import { createComponent } from "@vue/composition-api";
import { useDictionary } from "@dcc/views/compositions/useDictionary";
import { DictionaryField } from "../lookup/dictionary/fields";
interface WeeklyConsumptionProps {
  units: number;
  drinks: number;
  drinkType: Drinks;
  calories: number;
  burgers: number;
}

export default createComponent({
  components: {
    WeeklyConsumptionPanel
  },
  props: {
    units: {
      type: Number,
      required: true
    },
    drinks: {
      type: Number,
      required: true
    },
    drinkType: {
      type: String as () => Drinks,
      required: true
    },
    calories: {
      type: Number,
      required: true
    },
    burgers: {
      type: Number,
      required: true
    }
  },
  setup(props: WeeklyConsumptionProps) {
    const dictionary = useDictionary();
    const drinkText: string =
      props.drinkType === Drinks.beer
        ? dictionary.dictionary[DictionaryField.TOOLS_GENERAL_DRINKS]
        : dictionary.dictionary[DictionaryField.TOOLS_GENERAL_SINGLESPIRIT25];

    const drinkImageClass = props.drinkType === Drinks.beer ? "Beer" : "Spirit";

    const drinkImage =
      props.drinkType === Drinks.beer
        ? "https://drinkaware-web.azureedge.net/tools/tools/Beer.svg"
        : "https://drinkaware-web.azureedge.net/tools/tools/Spirit.svg";

    return {
      drinkText,
      drinkImage,
      drinkImageClass,
      ...dictionary
    };
  }
});
